import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from 'types'

export default function useIsMobile() {
  const mobile = useSelector((state: RootState) => state.mobile, shallowEqual)

  return mobile
}
